import { array, nullable, object, optional, string } from "superstruct";

import BaseCoRegistrantSchema from "./BaseCoRegistrantSchema";

const BaseGiftRegistrantSchema = object({
    firstName: string(),
    lastName: string(),
    address: nullable(string()),
    postalCode: nullable(string()),
    city: nullable(string()),
    state: nullable(string()),
    country: nullable(string()),
    coRegistrants: optional(array(BaseCoRegistrantSchema)),
});

export default BaseGiftRegistrantSchema;
